import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NginIframeComponent } from './components/ngin-iframe/ngin-iframe.component'

@NgModule({
  declarations: [
    NginIframeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NginIframeComponent
  ]
})
export class SeMySportsengineUiNginIframeModule {}
